import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../../assets/images/Logo-coloré.png'


const _hoisted_1 = { class: "tw-header-logo" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "teamWill Digital",
  class: "tw-header-logo-img"
}, null, -1)
const _hoisted_3 = { class: "tw-header-search" }
const _hoisted_4 = { class: "tw-header-nav" }
const _hoisted_5 = {
  key: 0,
  class: "tw-header-badge"
}
const _hoisted_6 = {
  key: 0,
  class: "tw-header-lang"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "tw-header-user-identity" }
const _hoisted_9 = { class: "tw-header-user-name" }
const _hoisted_10 = { class: "tw-header-user-role" }
const _hoisted_11 = { class: "col-1" }
const _hoisted_12 = { class: "col-11" }
const _hoisted_13 = { class: "q-ml-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_btn_dropdown = _resolveComponent("q-btn-dropdown")!
  const _component_QuickSearch = _resolveComponent("QuickSearch")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_LanguageProfil = _resolveComponent("LanguageProfil")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_header = _resolveComponent("q-header")!
  const _component_OrderMessagesPanel = _resolveComponent("OrderMessagesPanel")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_q_toolbar, { class: "tw-header" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_q_btn, {
                "data-testid": "menu_button",
                class: "tw-nav-trigger",
                id: "icon",
                flat: "",
                icon: "menu",
                onClick: _ctx.collapseToggle
              }, null, 8, ["onClick"]),
              _hoisted_2,
              (_ctx.delegations.length)
                ? (_openBlock(), _createBlock(_component_q_btn_dropdown, {
                    key: 0,
                    class: "tw-header-selector",
                    label: _ctx.selectUserDelegate.label,
                    flat: "",
                    "no-caps": "",
                    "dropdown-icon": "expand_more"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_list, null, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.delegations, (item) => {
                            return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                              key: item.value,
                              clickable: "",
                              onClick: ($event: any) => (_ctx.onSelectUser(item))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_item_section, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_item_label, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t(`main.delegation.${item.label}`)), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["onClick"])), [
                              [_directive_close_popup]
                            ])
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["label"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_QuickSearch, { "always-open": "" })
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("button", {
                type: "button",
                class: "tw-header-icon-btn",
                id: "bellBtn",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showMessages = true))
              }, [
                _createVNode(_component_q_icon, {
                  name: "notifications_none",
                  size: "20px"
                }),
                (_ctx.unreadCount > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.unreadCount), 1))
                  : _createCommentVNode("", true),
                _createVNode(_component_q_tooltip, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.messagesTooltip), 1)
                  ]),
                  _: 1
                })
              ]),
              (_ctx.languageToggles.length > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languageToggles, (lang) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: lang.id,
                        type: "button",
                        class: _normalizeClass(["tw-header-lang-btn", { 'is-active': lang.active }]),
                        onClick: ($event: any) => (_ctx.onSelectLanguage(lang.option))
                      }, _toDisplayString(lang.code), 11, _hoisted_7))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_q_btn_dropdown, {
                "content-class": "test",
                class: "tw-header-user",
                flat: "",
                "no-caps": "",
                "no-icon-animation": "",
                "dropdown-icon": "",
                floating: ""
              }, {
                label: _withCtx(() => [
                  _createElementVNode("span", _hoisted_8, [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.userFullName), 1),
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.userRole), 1)
                  ]),
                  _createVNode(_component_q_avatar, {
                    size: "34px",
                    color: "amber",
                    "text-color": "white"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.initials), 1)
                    ]),
                    _: 1
                  })
                ]),
                "dropdown-arrow": _withCtx(() => []),
                default: _withCtx(() => [
                  _createVNode(_component_LanguageProfil)
                ]),
                _: 1
              }),
              _createElementVNode("button", {
                type: "button",
                "data-testid": "logout_btn",
                class: "tw-header-icon-btn",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
              }, [
                _createVNode(_component_q_icon, {
                  name: "logout",
                  size: "19px"
                }),
                _createVNode(_component_q_tooltip, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.logoutTooltip), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_OrderMessagesPanel, {
      modelValue: _ctx.showMessages,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showMessages) = $event)),
      unreadCount: _ctx.unreadCount,
      "onUpdate:unreadCount": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.unreadCount) = $event)),
      "subjects-list": _ctx.subjectsList,
      "reference-options": _ctx.optionsReference,
      onMessageSent: _ctx.onMessageSent,
      alertList: _ctx.$store.state.alertList
    }, null, 8, ["modelValue", "unreadCount", "subjects-list", "reference-options", "onMessageSent", "alertList"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.confirmLogout,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.confirmLogout) = $event)),
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, { class: "row items-center" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_q_icon, {
                    name: "info",
                    color: "primary",
                    "text-color": "white",
                    size: "2rem"
                  })
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t("main.confirmationDialog.message")), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_actions, { align: "right" }, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  label: _ctx.confirmationButtonLabel,
                  color: "primary",
                  onClick: _ctx.onClickLogoutButton
                }, null, 8, ["label", "onClick"]), [
                  [_directive_close_popup]
                ]),
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  label: _ctx.cancelButtonLabel,
                  color: "primary"
                }, null, 8, ["label"]), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}